import React, { useMemo, useState } from "react";
import { Card, Button, Table } from "react-bootstrap";
import {
    ArrowLeft,
    ChevronDown,
    ChevronUp,
    ArrowUpCircle,
    BoxSeam,
    Grid3x3Gap,
} from "react-bootstrap-icons";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { useNavigate } from "react-router-dom";

const ItemRepeatDetails = () => {
    const navigate = useNavigate();
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);

    const [activeTab, setActiveTab] = useState("items");
    const [expandedRow, setExpandedRow] = useState(null);
    const [hoveredBar, setHoveredBar] = useState(null);
    const [showMore, setShowMore] = useState(false);

    const itemData = [
        {
            name: "Double Mocha Freezio",
            category: "Cold Beverages",
            repeatVisits: 225,
            contribution: 34,
            revenue: "₹68,500",
            customers: 184,
            avgGap: "8 days",
            trend: "+12%",
            drilldown: [
                { outlet: "Cafe Baner", repeatVisits: 72, customers: 58, revenue: "₹21,700" },
                { outlet: "Cafe Wakad", repeatVisits: 61, customers: 49, revenue: "₹18,200" },
                { outlet: "Cafe Kothrud", repeatVisits: 52, customers: 43, revenue: "₹15,900" },
            ],
        },
        {
            name: "Blueberry Freezio",
            category: "Cold Beverages",
            repeatVisits: 131,
            contribution: 18,
            revenue: "₹41,250",
            customers: 109,
            avgGap: "10 days",
            trend: "+8%",
            drilldown: [
                { outlet: "Cafe Baner", repeatVisits: 43, customers: 34, revenue: "₹13,400" },
                { outlet: "Cafe Wakad", repeatVisits: 37, customers: 31, revenue: "₹11,750" },
            ],
        },
        {
            name: "Cold Coffee",
            category: "Cold Beverages",
            repeatVisits: 58,
            contribution: 14,
            revenue: "₹19,300",
            customers: 46,
            avgGap: "11 days",
            trend: "+5%",
            drilldown: [
                { outlet: "Cafe Kothrud", repeatVisits: 24, customers: 19, revenue: "₹8,100" },
                { outlet: "Cafe Baner", repeatVisits: 21, customers: 17, revenue: "₹6,950" },
            ],
        },
        {
            name: "Masala Chai",
            category: "Hot Beverages",
            repeatVisits: 16,
            contribution: 11,
            revenue: "₹6,800",
            customers: 14,
            avgGap: "13 days",
            trend: "-2%",
            drilldown: [
                { outlet: "Cafe Wakad", repeatVisits: 8, customers: 7, revenue: "₹3,400" },
            ],
        },
        {
            name: "Chicken Pizza",
            category: "Food",
            repeatVisits: 12,
            contribution: 9,
            revenue: "₹9,600",
            customers: 10,
            avgGap: "15 days",
            trend: "+3%",
            drilldown: [
                { outlet: "Cafe Baner", repeatVisits: 6, customers: 5, revenue: "₹4,800" },
            ],
        },
    ];

    const categoryData = [
        {
            name: "Cold Beverages",
            topItem: "Double Mocha Freezio",
            repeatVisits: 414,
            contribution: 66,
            revenue: "₹1,29,050",
            customers: 339,
            avgGap: "9 days",
            trend: "+14%",
            drilldown: [
                { outlet: "Cafe Baner", repeatVisits: 139, customers: 111, revenue: "₹42,900" },
                { outlet: "Cafe Wakad", repeatVisits: 119, customers: 96, revenue: "₹36,700" },
                { outlet: "Cafe Kothrud", repeatVisits: 95, customers: 79, revenue: "₹29,850" },
            ],
        },
        {
            name: "Hot Beverages",
            topItem: "Masala Chai",
            repeatVisits: 74,
            contribution: 16,
            revenue: "₹28,400",
            customers: 61,
            avgGap: "12 days",
            trend: "+4%",
            drilldown: [
                { outlet: "Cafe Wakad", repeatVisits: 31, customers: 26, revenue: "₹11,900" },
                { outlet: "Cafe Baner", repeatVisits: 24, customers: 19, revenue: "₹9,300" },
            ],
        },
        {
            name: "Food",
            topItem: "Chicken Pizza",
            repeatVisits: 52,
            contribution: 12,
            revenue: "₹39,200",
            customers: 43,
            avgGap: "14 days",
            trend: "+6%",
            drilldown: [
                { outlet: "Cafe Baner", repeatVisits: 22, customers: 18, revenue: "₹16,700" },
                { outlet: "Cafe Kothrud", repeatVisits: 17, customers: 14, revenue: "₹12,900" },
            ],
        },
        {
            name: "Desserts",
            topItem: "Chocolate Brownie",
            repeatVisits: 28,
            contribution: 6,
            revenue: "₹14,800",
            customers: 24,
            avgGap: "16 days",
            trend: "-1%",
            drilldown: [
                { outlet: "Cafe Wakad", repeatVisits: 12, customers: 10, revenue: "₹6,300" },
            ],
        },
    ];

    const activeData = activeTab === "items" ? itemData : categoryData;
    const displayedData = showMore ? activeData : activeData.slice(0, 5);

    const totalRepeatVisits = activeData.reduce((sum, item) => sum + item.repeatVisits, 0);
    const topDriver = activeData[0];
    const maxVisits = Math.max(...activeData.map((item) => item.repeatVisits));

    return (
        <>
            <Header onSkin={setSkin} />

            <div className="main main-app">
                <div style={{ background: "#ffffff", minHeight: "100vh", padding: 28 }}>
                    <div style={topActionStyle}>
                        <Button
                            variant="light"
                            onClick={() => navigate("/dashboard")}
                            style={backButtonStyle}
                        >
                            <ArrowLeft size={18} /> Go Back
                        </Button>

                        <Button variant="light" style={filterStyle}>
                            Last 12 Months <ChevronDown size={18} />
                        </Button>
                    </div>

                    <h1 style={pageTitleStyle}>
                        Which {activeTab === "items" ? "items" : "categories"} are driving{" "}
                        <span style={{ color: "#1F73EA" }}>repeat visits?</span>
                    </h1>

                    <div style={tabWrapStyle}>
                        <button
                            type="button"
                            onClick={() => {
                                setActiveTab("items");
                                setExpandedRow(null);
                            }}
                            style={activeTab === "items" ? activeTabStyle : tabStyle}
                        >
                            <BoxSeam size={17} /> Items
                        </button>

                        <button
                            type="button"
                            onClick={() => {
                                setActiveTab("category");
                                setExpandedRow(null);
                            }}
                            style={activeTab === "category" ? activeTabStyle : tabStyle}
                        >
                            <Grid3x3Gap size={17} /> Category
                        </button>
                    </div>

                    <Card style={{ ...mainCardStyle, background: "#EAF6FF" }}>
                        <Card.Body style={{ padding: 24 }}>
                            <div className="details-top-grid" style={topGridStyle}>
                                <div>
                                    <div style={badgeStyle}>
                                        {activeTab === "items" ? "Item Mix" : "Category Mix"}
                                    </div>

                                    <h1 style={amountStyle}>{totalRepeatVisits}</h1>

                                    <p style={subTextStyle}>
                                        repeat visits generated from{" "}
                                        {activeTab === "items" ? "top items" : "top categories"}.
                                        Top driver is <strong>{topDriver.name}</strong> with{" "}
                                        <strong>{topDriver.contribution}%</strong> contribution.
                                    </p>

                                    <div style={summaryBoxStyle}>
                                        <KpiBox label="Top Repeat Driver" value={topDriver.name} />
                                        <KpiBox label="Repeat Customers" value={topDriver.customers} />
                                        <KpiBox label="Avg Return Gap" value={topDriver.avgGap} />
                                    </div>
                                </div>

                                <div style={chartBoxStyle}>
                                    <div style={chartStyle}>
                                        {activeData.map((item, index) => {
                                            const height = Math.max((item.repeatVisits / maxVisits) * 190, 28);

                                            return (
                                                <div
                                                    key={item.name}
                                                    style={chartItemStyle}
                                                    onMouseEnter={() => setHoveredBar(index)}
                                                    onMouseLeave={() => setHoveredBar(null)}
                                                >
                                                    {hoveredBar === index && (
                                                        <div style={{ ...tooltipStyle, bottom: height + 58 }}>
                                                            <div style={tooltipTitleStyle}>{item.name}</div>
                                                            <TooltipRow label="Repeat Visits" value={item.repeatVisits} />
                                                            <TooltipRow label="Contribution" value={`${item.contribution}%`} />
                                                            <TooltipRow label="Revenue" value={item.revenue} highlight />
                                                        </div>
                                                    )}

                                                    <div style={chartValueStyle}>{item.repeatVisits}</div>

                                                    <div
                                                        style={{
                                                            ...barStyle,
                                                            height,
                                                            background:
                                                                index === 0
                                                                    ? "linear-gradient(180deg, #3FA7FF 0%, #0B5ED7 100%)"
                                                                    : "linear-gradient(180deg, #7CCBFF 0%, #1F73EA 100%)",
                                                        }}
                                                    />

                                                    <div style={chartLabelStyle}>
                                                        {index === 0 && <span>👑 </span>}
                                                        {item.name.length > 11 ? `${item.name.slice(0, 11)}...` : item.name}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                    <h2 style={sectionTitleStyle}>
                        {activeTab === "items" ? "Item-wise" : "Category-wise"}{" "}
                        <span style={{ color: "#1F73EA" }}>repeat performance</span>
                    </h2>

                    <div style={{ marginTop: 20 }}>
                        <Table borderless responsive style={{ marginBottom: 0 }}>
                            <thead>
                                <tr>
                                    <th style={tableHeadStyle}>
                                        {activeTab === "items" ? "Item Name" : "Category Name"}
                                    </th>
                                    <th style={tableHeadStyle}>
                                        {activeTab === "items" ? "Category" : "Top Item"}
                                    </th>
                                    <th style={tableHeadStyle}>Repeat Visits ↕</th>
                                    <th style={tableHeadStyle}>Repeat Customers ↕</th>
                                    <th style={tableHeadStyle}>Contribution ↕</th>
                                    <th style={tableHeadStyle}>Revenue ↕</th>
                                </tr>
                            </thead>

                            <tbody>
                                {displayedData.map((item) => (
                                    <React.Fragment key={item.name}>
                                        <tr
                                            style={{ cursor: "pointer" }}
                                        >
                                            <td style={tableCellStyle}>
                                                <strong>{item.name}</strong>
                                            </td>

                                            <td style={tableCellStyle}>
                                                {activeTab === "items" ? item.category : item.topItem}
                                            </td>

                                            <td style={tableCellStyle}>{item.repeatVisits}</td>
                                            <td style={tableCellStyle}>{item.customers}</td>
                                            <td style={tableCellStyle}>{item.contribution}%</td>
                                            <td style={tableCellStyle}>{item.revenue}</td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <Footer />
            </div>

            <style>
                {`
          tbody tr {
            background: #f7fbfb;
            border-radius: 14px;
          }

          tbody td {
            padding: 18px 22px !important;
            font-weight: 500;
            color: #344244;
          }

          tbody tr td:first-child {
            border-radius: 14px 0 0 14px;
          }

          tbody tr td:last-child {
            border-radius: 0 14px 14px 0;
          }

          tbody tr {
            border-bottom: 14px solid #fff;
          }

          @media (max-width: 992px) {
            .details-top-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
            </style>
        </>
    );
};

const KpiBox = ({ label, value, positive }) => {
    return (
        <div style={kpiBoxStyle}>
            <span style={kpiLabelStyle}>{label}</span>
            <strong style={{ ...kpiValueStyle, color: positive ? "#07996F" : "#071C1F" }}>
                {positive && <ArrowUpCircle size={14} />} {value}
            </strong>
        </div>
    );
};

const TooltipRow = ({ label, value, highlight }) => {
    return (
        <div style={tooltipRowStyle}>
            <span style={{ color: "#64748B" }}>{label}</span>
            <strong style={{ color: highlight ? "#1F73EA" : "#111827" }}>{value}</strong>
        </div>
    );
};

const topActionStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
};

const backButtonStyle = {
    border: "1px solid #d8dee4",
    borderRadius: 14,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    gap: 8,
};

const filterStyle = {
    border: "1px solid #d8dee4",
    borderRadius: 10,
    fontWeight: 600,
    color: "#17292b",
    padding: "11px 16px",
    display: "flex",
    alignItems: "center",
    gap: 40,
};

const pageTitleStyle = {
    fontSize: 32,
    fontWeight: 600,
    color: "#071C1F",
    marginBottom: 12,
};

const tabWrapStyle = {
    display: "inline-flex",
    background: "#EAF6FF",
    padding: 6,
    borderRadius: 14,
    marginBottom: 22,
    gap: 6,
};

const tabStyle = {
    border: 0,
    background: "transparent",
    color: "#17292b",
    borderRadius: 11,
    padding: "10px 18px",
    fontWeight: 800,
    display: "flex",
    alignItems: "center",
    gap: 8,
};

const activeTabStyle = {
    ...tabStyle,
    background: "#1F73EA",
    color: "#ffffff",
    boxShadow: "0 8px 18px rgba(31, 115, 234, 0.25)",
};

const mainCardStyle = {
    border: "1px solid #dce5e7",
    borderRadius: 18,
    boxShadow: "none",
};

const topGridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 390px",
    gap: 36,
    alignItems: "center",
};

const badgeStyle = {
    display: "inline-flex",
    padding: "7px 20px",
    background: "#ffffff",
    border: "1px solid #d8dee4",
    borderRadius: 14,
    fontSize: 14,
    fontWeight: 800,
    color: "#111827",
    marginBottom: 18,
};

const amountStyle = {
    fontSize: 48,
    fontWeight: 700,
    color: "#071C1F",
    marginBottom: 12,
};

const subTextStyle = {
    fontSize: 17,
    fontWeight: 500,
    color: "#071C1F",
    marginBottom: 22,
    maxWidth: 650,
};

const summaryBoxStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 12,
};

const kpiBoxStyle = {
    background: "#ffffff",
    borderRadius: 16,
    padding: 14,
    border: "1px solid #dce5e7",
};

const kpiLabelStyle = {
    display: "block",
    color: "#64748B",
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 6,
};

const kpiValueStyle = {
    fontSize: 15,
    display: "flex",
    alignItems: "center",
    gap: 5,
};

const chartBoxStyle = {
    background: "#ffffff",
    borderRadius: 18,
    padding: "18px 18px 14px",
    minHeight: 292,
};

const chartStyle = {
    height: 260,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 14,
};

const chartItemStyle = {
    flex: 1,
    minWidth: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    position: "relative",
};

const chartValueStyle = {
    fontSize: 13,
    fontWeight: 800,
    color: "#071C1F",
    marginBottom: 8,
};

const barStyle = {
    width: "100%",
    maxWidth: 48,
    borderRadius: "12px 12px 0 0",
    boxShadow: "0 8px 18px rgba(31, 115, 234, 0.2)",
    cursor: "pointer",
};

const chartLabelStyle = {
    marginTop: 12,
    height: 34,
    maxWidth: 82,
    fontSize: 12,
    fontWeight: 700,
    color: "#475467",
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
};

const tooltipStyle = {
    position: "absolute",
    background: "#ffffff",
    borderRadius: 14,
    padding: 12,
    width: 210,
    boxShadow: "0 12px 35px rgba(0,0,0,0.16)",
    zIndex: 20,
    textAlign: "left",
};

const tooltipTitleStyle = {
    fontSize: 12,
    fontWeight: 800,
    color: "#071C1F",
    marginBottom: 10,
};

const tooltipRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: 14,
    fontSize: 14,
    marginTop: 8,
};

const sectionTitleStyle = {
    fontSize: 34,
    fontWeight: 600,
    color: "#071C1F",
    margin: "34px 0 22px",
};

const tableHeadStyle = {
    fontSize: 17,
    color: "#344244",
    fontWeight: 800,
    padding: "0 22px 16px",
    whiteSpace: "nowrap",
};

const tableCellStyle = {
    fontSize: 16,
    verticalAlign: "middle",
    whiteSpace: "nowrap",
};

const smallTableHeadStyle = {
    fontSize: 14,
    color: "#64748B",
    fontWeight: 800,
    padding: "0 16px 12px",
    whiteSpace: "nowrap",
};

const smallTableCellStyle = {
    fontSize: 14,
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    padding: "14px 16px",
};

const drilldownBoxStyle = {
    background: "#EAF6FF",
    border: "1px solid #dce5e7",
    borderRadius: 16,
    padding: 18,
};

const showMoreButtonStyle = {
    border: 0,
    background: "transparent",
    fontWeight: 800,
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 8,
};

export default ItemRepeatDetails;